/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import { AvailabilityDelayEnum } from './availabilityDelayEnum';
import { NullEnum } from './nullEnum';

export type PatchedTrainingServicePreferencesAvailabilityDelay =
  | (typeof PatchedTrainingServicePreferencesAvailabilityDelay)[keyof typeof PatchedTrainingServicePreferencesAvailabilityDelay]
  | null;

export const PatchedTrainingServicePreferencesAvailabilityDelay = {
  ...AvailabilityDelayEnum,
  ...NullEnum,
} as const;
